// eslint-disable-next-line no-restricted-imports
import { Modal as AntdModal } from 'antd'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = Omit<
  ComponentPropsWithoutRef<typeof AntdModal>,
  'footer' | 'classNames' | 'destroyOnClose'
>

/**
 * Antd の Modal をラップしたコンポーネント
 * - Props の footer を 廃止して children で定義するよう変更
 * - Modal自体の余白を削除して各子要素で調整するよう変更
 * - maskClosable をデフォルトで false に変更
 */
export const Modal: FC<Props> = ({
  children,
  maskClosable = false,
  ...props
}) => {
  return (
    <AntdModal
      footer={null}
      destroyOnClose
      maskClosable={maskClosable}
      classNames={{
        content: '!p-0',
        body: 'border-t !border-gray-100 !p-0',
        header: '!px-6 !py-4 !mb-0'
      }}
      {...props}
    >
      {children}
    </AntdModal>
  )
}
